import { render, staticRenderFns } from "./UserLocations.vue?vue&type=template&id=3e512cec&scoped=true&"
import script from "./UserLocations.vue?vue&type=script&lang=js&"
export * from "./UserLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e512cec",
  null
  
)

export default component.exports